import { createApi, createDomain } from 'effector';

const domain = createDomain('sdk');

export const $isSDK = domain.store<boolean>(false);
export const $isSDKApi = createApi($isSDK, {
  set: (_, payload: boolean) => payload,
});
